const productData = [
  {
    id: 1,
    name: "Cinch Jean",
    category: "Pants",
    price: "299.9",
    reviews: "342",
    rating: "4.6",
    image: "/img/101.webp",
    images: ["/img/101.webp", "/img/101a.webp", "/img/101b.webp", "/img/101c.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL", "1X"],
    colors: ["Salt", "Light Wash"],
    material: "Recycled cotton denim",
    description: [
      "Mid‑rise denim cut with an adjustable drawstring waist for a custom fit.",
      "Single front pleats add subtle visual interest and relaxed comfort.",
      "Slightly relaxed leg keeps the silhouette easy and versatile.",
      "Made from recycled cotton denim; durable with soft hand feel.",
      "Pairs effortlessly with tanks, tees and knitwear for everyday wear.",
      "For extra room to cinch, size up; wardrobe staple that works year‑round.",
      "Designed for EU sizing; true to size with room to adjust at waist.",
    ],
    Features: [
      "Adjustable drawstring waistband",
      "Front pleat detailing",
      "Relaxed straight leg",
      "Recycled cotton denim",
      "Five‑pocket construction",
      "Machine wash cold, line dry",
      "EU size scale XXS–1X",
    ],
  },
  {
    id: 2,
    name: "Ronnie Jean",
    category: "Pants",
    price: "299.9",
    reviews: "289",
    rating: "4.7",
    image: "/img/102.webp",
    images: ["/img/102.webp", "/img/102a.webp"],
    size: ["24","25","26","27","28","29","30","31","32","33"],
    colors: ["Light Wash","Vintage Black","Vintage Dark","Putty","Salt"],
    material: "Recycled cotton denim",
    description: [
      "High‑rise jean with clean lines and a softly relaxed leg.",
      "Sculpted waist and hip for a flattering, easy‑to‑wear fit.",
      "Washed for softness while maintaining structure.",
      "Designed to sit at ankle with room through the thigh.",
      "Pairs with simple tanks and oversized knits.",
      "European size run 24–33; choose your usual waist size.",
    ],
    Features: [
      "High‑rise fit",
      "Straight, relaxed leg",
      "Recycled denim fabrication",
      "Washed finish for softness",
      "Zip fly with button closure",
      "Multiple washes: Light, Vintage Black/Dark, Putty, Salt",
    ],
  },
  {
    id: 3,
    name: "Edie Vest",
    category: "Shirts",
    price: "179.9",
    reviews: "214",
    rating: "4.5",
    image: "/img/103.webp",
    images: ["/img/103.webp", "/img/103a.webp"],
    size: ["XS/S", "M/L", "XL/XXL"],
    colors: ["Ecru", "Soft Black"],
    material: "Textured cotton blend",
    description: [
      "Layering vest with clean neckline and subtle shaping through the body.",
      "Textured fabric with soft drape for comfort and ease.",
      "Designed to slip over tees and shirting or worn alone.",
      "Versatile proportions that balance high‑rise denim and skirts.",
      "Minimal detailing for a timeless, pared‑back look.",
      "EU dual sizes XS/S, M/L, XL/XXL for easy fit.",
    ],
    Features: [
      "Clean V‑neckline",
      "Subtle waist shaping",
      "Breathable cotton blend",
      "Fully lined construction",
      "Easy slip‑on fit",
      "Neutral colours: Ecru, Soft Black",
    ],
  },
  {
    id: 4,
    name: "Otis Top",
    category: "Shirts",
    price: "179.9",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.webp",
    images: ["/img/104.webp", "/img/104a.webp", "/img/104b.webp"],
    size: ["XS/S", "M/L", "XL/XXL"],
    colors: ["Ecru", "Soft Black"],
    material: "Pressed wool blend",
    description: [
      "Refined knit top with softly structured shoulder line.",
      "Smooth finish that dresses up or down with ease.",
      "Proportioned to layer under jackets while comfortable worn alone.",
      "Subtle drape and clean hem for polished outfitting.",
      "Pairs effortlessly with denim, tailored pants and skirts.",
      "Dual EU sizing for a relaxed yet tailored look.",
    ],
    Features: [
      "Minimal crew neckline",
      "Soft hand feel",
      "Clean hem finish",
      "Seasonless weight",
      "Dry clean recommended",
      "Colours: Ecru, Soft Black",
    ],
  },
  {
    id: 5,
    name: "Uno Tank",
    category: "Tees",
    price: "89.9",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.webp",
    images: ["/img/105.webp", "/img/105a.webp", "/img/105b.jpg", "/img/105c.jpg"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Neutral", "Gold"],
    material: "Cotton rib",
    description: [
      "Slim tank with fine rib texture and a flattering neckline.",
      "Soft hand feel with gentle stretch for everyday comfort.",
      "Layers seamlessly under shirts and jackets.",
      "Clean finish at armholes and neck for a polished look.",
      "Available in neutral tones to complement seasonal palettes.",
      "EU sizes XXS–XL; stretch comfort for daily wear.",
    ],
    Features: [
      "Fine rib fabrication",
      "Scoop neckline",
      "Stretch comfort",
      "Clean bound edges",
      "Machine wash cold",
      "Soft cotton rib suitable for layering",
    ],
  },
  {
    id: 6,
    name: "Bigger Tee",
    category: "Tee",
    price: "69.9",
    reviews: "198",
    rating: "4.4",
    image: "/img/106.webp",
    images: ["/img/106.webp", "/img/106a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Plum Blur", "Beige"],
    material: "Cotton jersey",
    description: [
      "Relaxed tee with a boxy fit and dropped shoulder.",
      "Soft cotton jersey that drapes effortlessly.",
      "Perfect proportion for tucking or wearing loose.",
      "Minimal branding for a timeless feel.",
      "Designed for layering and standalone wear.",
      "EU sizes XXS–XXL; boxy cut drapes naturally.",
    ],
    Features: [
      "Boxy silhouette",
      "Dropped shoulder",
      "Soft cotton jersey",
      "Bound neckline",
      "Machine washable",
      "Pre‑washed for softness",
    ],
  },
  {
    id: 7,
    name: "Denim Marcie Shirt",
    category: "Shirt",
    price: "149.9",
    reviews: "240",
    rating: "4.7",
    image: "/img/107.webp",
    images: ["/img/107.webp", "/img/107a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Mocha", "Heather"],
    material: "Denim blend",
    description: [
      "Classic denim shirt reimagined with subtle tailoring.",
      "Clean collar and refined stitching details.",
      "Softly washed for comfort with a structured drape.",
      "Layer over tanks or buttoned up for polish.",
      "Natural handfeel with a lived‑in softness.",
      "Cut for EU sizing; regular fit through shoulder.",
    ],
    Features: [
      "Button‑front closure",
      "Chest pocket",
      "Washed denim feel",
      "Tailored seams",
      "Curved hem",
      "Durable stitching throughout",
    ],
  },
  {
    id: 8,
    name: "Chleo Crew",
    category: "Sweaters",
    price: "179.9",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.webp",
    images: ["/img/108.webp", "/img/108a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Brown", "Olive"],
    material: "Wool blend knit",
    description: [
      "Crewneck knit with an easy straight fit.",
      "Warm yet lightweight yarn with soft touch.",
      "Rib trims at neckline, cuff and hem.",
      "Made for layering through changing seasons.",
      "Breathable gauge suitable for indoor and outdoor wear.",
      "Classic straight fit; true to EU sizing.",
    ],
    Features: [
      "Crew neckline",
      "Rib trims",
      "Soft wool blend",
      "Standard length",
      "Hand wash or dry clean",
      "Seasonal neutral colours",
    ],
  },
  {
    id: 9,
    name: "Classic Tank",
    category: "Tees",
    price: "99.9",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.webp",
    images: ["/img/109.webp", "/img/109a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Trail Green", "Stone"],
    material: "Cotton rib",
    description: [
      "Essential rib tank with clean neckline and slim fit.",
      "Soft hand with stretch for all‑day comfort.",
      "An elevated base layer for denim and tailoring.",
      "Finished with neat binding at edges.",
      "A core style for everyday rotation.",
      "Stretch rib conforms gently to body in EU sizes.",
    ],
    Features: [
      "Slim rib knit",
      "Stretch comfort",
      "Scoop neck",
      "Clean binding",
      "Machine washable",
      "Retains shape after wash",
    ],
  },
  {
    id: 10,
    name: "Marcie Shirt",
    category: "Shirt",
    price: "159.9",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010.jpg",
    images: ["/img/1010.jpg", "/img/1010a.jpg"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Black", "Charcoal"],
    material: "Cotton poplin",
    description: [
      "Straight‑cut shirt with crisp poplin hand feel.",
      "Refined collar and concealed button placket.",
      "Easy length designed to be tucked or worn loose.",
      "Works with denim, tailoring and skirts alike.",
      "Tailored yet relaxed for modern ease.",
      "EU sizing with refined shoulder for comfort.",
    ],
    Features: [
      "Crisp poplin fabric",
      "Concealed placket",
      "Tailored collar",
      "Back yoke with pleat",
      "Curved hem",
      "Easy‑care crease resistance",
    ],
  },
  {
    id: 11,
    name: "Rib Tee",
    category: "Tee",
    price: "79.9",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.webp",
    images: ["/img/1011.webp", "/img/1011a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Charcoal", "Rose"],
    material: "Cotton rib jersey",
    description: [
      "Ribbed tee with a close fit and soft stretch.",
      "Minimal design for elevated everyday dressing.",
      "Neat sleeve length balances the proportion.",
      "Perfect base layer under blazers and cardigans.",
      "Sits close to the body without clinging for comfort.",
      "Sized for EU fits; choose usual size for a close cut.",
    ],
    Features: [
      "Stretch rib jersey",
      "Crew neckline",
      "Clean finish seams",
      "Machine wash cold",
      "Breathable cotton fibers",
      "Soft touch fabric",
    ],
  },
  {
    id: 12,
    name: "Lou Tee",
    category: "Jackets",
    price: "249.9",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.webp",
    images: ["/img/1012.webp", "/img/1012a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Gunmetal", "Blush"],
    material: "Wool blend",
    description: [
      "Longline coat with subtle volume at the sleeve.",
      "Pressed wool finish for a polished, minimal look.",
      "Warm and versatile for layered outfits.",
      "Streamlined silhouette with clean details.",
      "Cut to skim over layers for comfort and ease.",
      "EU sizing; intended for a relaxed, longline fit.",
    ],
    Features: [
      "Pressed wool fabric",
      "Subtle sleeve volume",
      "Full lining",
      "Concealed button front",
      "Streamlined seams for a neat finish",
      "Internal pocketing for essentials",
    ],
  },
  {
    id: 13,
    name: "Carmen Jean",
    category: "Pants",
    price: "249.9",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.webp",
    images: ["/img/1013.webp", "/img/1013a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Taupe", "Stone"],
    material: "Cotton denim",
    description: [
      "Classic jean with refined straight leg and clean rise.",
      "Subtle wash for softness while holding structure.",
      "Designed for everyday wear and easy styling.",
      "Balanced proportion through thigh and knee for comfort.",
      "Timeless silhouette that pairs across seasons.",
      "EU sizing; straight leg designed for everyday wear.",
    ],
    Features: [
      "Straight‑leg silhouette",
      "Zip fly",
      "Five‑pocket construction",
      "Washed denim finish",
      "Reinforced belt loops",
      "Comfort rise",
    ],
  },
  {
    id: 14,
    name: "Christy Bodysuit",
    category: "Tees",
    price: "109.9",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.webp",
    images: ["/img/1014.webp", "/img/1014a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Cognac Swirl", "Black"],
    material: "Stretch jersey",
    description: [
      "Sleek bodysuit with clean neckline and smooth finish.",
      "Secure snap closure with gentle stretch for comfort.",
      "Ideal layering base under denim and tailoring.",
      "Smooth handfeel that sits flat under layers.",
      "Designed to move with the body throughout the day.",
      "EU sizing; snap closure for secure fit.",
    ],
    Features: [
      "Stretch jersey body",
      "Snap‑button closure",
      "Clean edge binding",
      "Form‑skimming fit",
      "Breathable, lightweight construction",
      "Flat seams for comfort",
    ],
  },
  {
    id: 15,
    name: "Marcie Shirt",
    category: "Shirt",
    price: "169.9",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.jpg",
    images: ["/img/1015.jpg", "/img/1015a.jpg"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Leopard", "Ivory"],
    material: "Silk blend",
    description: [
      "Fluid shirt with soft drape and refined buttons.",
      "Relaxed fit through body with tailored collar.",
      "Elevates denim and skirts with ease.",
      "Subtle sheen enhances the fabric’s movement.",
      "Relaxed EU fit with tailored collar.",
    ],
    Features: [
      "Silk‑blend fabric",
      "Button‑front closure",
      "Relaxed cut",
      "Curved hem",
      "Soft drape",
    ],
  },
  {
    id: 16,
    name: "Zip Popover",
    category: "Shirts",
    price: "129.9",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.webp",
    images: ["/img/1016.webp", "/img/1016a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Neutral", "Olive"],
    material: "Cotton twill",
    description: [
      "Popover top with half zip and structured collar.",
      "Clean lines and easy fit for everyday dressing.",
      "Pairs well with denim and tailored pants.",
      "Durable twill with soft handfeel.",
      "Versatile layer for transitional weather.",
      "EU sizing; easy overhead entry with half‑zip.",
    ],
    Features: [
      "Half‑zip front",
      "Stand collar",
      "Straight hem",
      "Twill fabrication",
      "Reinforced stitching at stress points",
      "Wear‑tested for mobility",
    ],
  },
  {
    id: 17,
    name: "Loretta Jacket",
    category: "Jacket",
    price: "199.9",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.webp",
    images: ["/img/1017.webp", "/img/1017a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Midnight Blue", "White"],
    material: "Cotton blend",
    description: [
      "Minimal jacket with clean front and refined seams.",
      "Lightweight structure for transitional layering.",
      "Easy to dress up or down across seasons.",
      "Streamlined silhouette with modern proportion.",
      "Soft lining for comfort against the skin.",
      "EU sizing; tailored through shoulder, easy through body.",
    ],
    Features: [
      "Clean front construction",
      "Tailored seams",
      "Lightweight structure",
      "Fully lined",
      "Inside pocket for essentials",
      "Back vent for movement",
    ],
  },
  {
    id: 18,
    name: "Field Pant",
    category: "Pants",
    price: "149.9",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.webp",
    images: ["/img/1018.webp", "/img/1018a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Mulberry", "Sand"],
    material: "Cotton twill",
    description: [
      "Straight‑leg field pant with utility‑inspired details.",
      "Comfortable rise and easy fit through the leg.",
      "Soft twill finish that wears in beautifully.",
      "Sturdy fabric designed for daily wear.",
      "Works with tees and shirts for laid‑back styling.",
      "EU sizing; utility details kept minimal for clean look.",
    ],
    Features: [
      "Straight leg",
      "Utility‑inspired pockets",
      "Durable twill",
      "Zip fly",
      "Reinforced seat seams",
      "Bartacks at stress points",
    ],
  },
  {
    id: 19,
    name: "Perla Cardi",
    category: "Sweaters",
    price: "189.9",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.webp",
    images: ["/img/1019.webp", "/img/1019a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Gunmetal", "Ivory"],
    material: "Wool blend knit",
    description: [
      "Classic cardigan with neat rib trims and a clean V‑neck.",
      "Soft wool blend with warmth and light drape.",
      "Layer over tees and dresses through the season.",
      "Refined buttons and clean placket.",
      "Ideal for office and weekend outfits alike.",
      "EU sizing; neat rib trims maintain shape.",
    ],
    Features: [
      "V‑neck cardigan",
      "Button front",
      "Rib trims",
      "Soft wool blend",
      "Standard hip length",
      "Fully fashioned knitting",
    ],
  },
  {
    id: 20,
    name: "Sloan Cardigan",
    category: "Sweaters",
    price: "169.9",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.webp",
    images: ["/img/1020.webp", "/img/1020a.webp"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Black with Gunmetal", "Blush"],
    material: "Merino blend",
    description: [
      "Relaxed cardigan with soft, slouchy silhouette.",
      "Merino blend yarn offers warmth with breathable comfort.",
      "Designed for effortless layering over tanks and tees.",
      "Rib cuffs and hem keep shape through wear.",
      "Easy throw‑on style for cool mornings and evenings.",
      "EU sizing; relaxed cut drapes effortlessly.",
    ],
    Features: [
      "Relaxed fit",
      "Soft merino blend",
      "Rib cuff and hem",
      "Button closure",
      "Mid length for versatile styling",
      "Breathable knit gauge",
    ],
  },
];

export default productData;
